export default __webpack_public_path__ + "static/media/jasmine_and_ian-0676.f877fe50.jpg";